<ul class="menu" [nzTheme]="'dark'" nz-menu nzMode="inline" [nzInlineCollapsed]="mmInlineCollapsed">
    <ng-container *ngFor="let item of items$ | async">
        <ng-container *ngTemplateOutlet="menuItem; context:{data:item,paths:[item.path]}">
        </ng-container>
    </ng-container>

    <ng-template #menuItem let-data="data" let-paths="paths">
        <ng-container *ngIf="hasItems(data)">
            <li class="menu-item" nz-submenu [nzTitle]="menuName(data) | async" [nzIcon]="data.icon">
                <ul class="menu" [nzTheme]="'dark'" nz-menu nzMode="inline">
                    <ng-container *ngFor="let item of data.items">
                        <ng-container
                            *ngTemplateOutlet="menuItem; context:{data:item,paths:combinePaths(paths,item.path)}">
                        </ng-container>
                    </ng-container>
                </ul>
            </li>
        </ng-container>
        <ng-container *ngIf="!hasItems(data)">
            <li class="menu-item" nz-menu-item (click)="navigate(paths)">
                <span title>
                    <i nz-icon [nzType]="data.icon" nzTheme="outline"></i>
                    <span class="first-level-title">{{menuName(data) | async }}</span>
                </span>
            </li>
        </ng-container>
    </ng-template>
</ul>